import React from 'react';
import { useMarketplace, Marketplace } from '../../contexts/MarketplaceContext';
import styles from './MarketplaceSwitch.module.scss';
import classNames from 'classnames';

const MarketplaceSwitch: React.FC = () => {
	const { currentMarketplace, switchMarketplace } = useMarketplace();

	const handleSwitch = (marketplace: Marketplace) => {
		switchMarketplace(marketplace);
	};

	return (
		<div className={styles.container}>
			<button
				className={classNames(styles.button, {
					[styles.active]: currentMarketplace === 'wb',
				})}
				onClick={() => handleSwitch('wb')}
			>
				WB
			</button>
			<button
				className={classNames(styles.button, {
					[styles.active]: currentMarketplace === 'ozon',
				})}
				onClick={() => handleSwitch('ozon')}
			>
				OZON
			</button>
		</div>
	);
};

export default MarketplaceSwitch; 